var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"services mb-4",style:({ background: `url(${_vm.serviceImg})` })},[_c('h2',{staticClass:"service-title"},[_vm._v(_vm._s(_vm.title))]),_c('ul',{staticClass:"service-list"},_vm._l((_vm.services),function(service){return _c('li',{key:service},[_vm._v(_vm._s(service))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }